export default "__VITE_ASSET__TY9v$viY__"